import React, { useContext } from "react";
import styled from "styled-components";

import Button from "../common/Button";
import { ExamContext } from "../exam/context/examContext";

import Modal from "./Modal";

//todo: swap these to common-ui
const PrimaryButton = styled(Button)`
  background-color: #006699;
  color: white;
  border: none;
  cursor: pointer;
  text-transform: uppercase;
  font-weight: bold;

  &:hover {
    background-color: #0170a7;
  }
`;
const StyledMessage = styled.div`
  padding: 2rem;
`;

type PauseModalProps = {
  isTeacherPaused?: boolean;
  isPaused?: boolean;
};
export const PauseModal = (props: PauseModalProps) => {
  const [state, dispatch] = useContext(ExamContext);
  return (
    <Modal
      isOpen={!!props.isTeacherPaused || !!state.isPaused}
      title="Activity Paused"
      hideCloseButton
      onRequestClose={() => {
        if (props.isTeacherPaused) return;
        dispatch({
          type: "SET_PAUSE",
          isPaused: false,
        });
      }}
      buttons={
        !props.isTeacherPaused && (
          <PrimaryButton
            onClick={() => {
              if (props.isTeacherPaused) return;
              return dispatch({
                type: "SET_PAUSE",
                isPaused: false,
              });
            }}
          >
            <div style={{ padding: "1.5rem 1rem" }}>Resume</div>
          </PrimaryButton>
        )
      }
    >
      {props.isTeacherPaused ? (
        <StyledMessage>
          This activity has been paused by your instructor.
        </StyledMessage>
      ) : (
        <StyledMessage>
          Your activity has been paused. Click Resume to continue your activity.
        </StyledMessage>
      )}
    </Modal>
  );
};
